var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('iframe',{staticClass:"preview-content",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }